import PropTypes from 'prop-types';
import Tile from '@/components/common/Tile';
import { formatData } from '@/utils/itemSelectorUtils';
import styles from './BlocSelector.module.scss';

const BlocSelector = ({ t, locale, currencyISO, items, itemSelected, onSelect, isMobileOrTablet, rowStyle = false }) => {
	const lowStock = [1, 2].includes(itemSelected?.stock);

	const blocClassName = [
		styles.blocs,
		isMobileOrTablet && !rowStyle && styles['mobile-or-tablet'],
		!isMobileOrTablet && styles['desktop'],
		rowStyle && styles.row,
	]
		.filter(Boolean)
		.join(' ');

	return (
		items.length > 0 && (
			<div className={styles['bloc-selector']} data-test-id="bloc-selector" data-rbf="bloc-selector">
				<div className={styles['item-selected']} data-test-id="item-selected" data-rbf="item-selected">
					{itemSelected?.attributes?.conditionnement?.name && (
						<>
							<span className={styles.title}>{itemSelected.attributes.conditionnement.name}</span>
							{' : '}
						</>
					)}
					{itemSelected?.shortdesc}
				</div>
				<div className={blocClassName} data-test-id="blocs" data-rbf="blocs">
					{items.length >= 1 &&
						items
							.map((item) => formatData(t, item, locale, currencyISO))
							.map((item) => (
								<Tile
									key={item.id}
									centered
									selected={itemSelected?.partnumber === item.value}
									onClick={() => onSelect(item.value)}
									content={{
										paragraph: item?.conditionnementId === '2F' ? 'Caisse Variation' : item.label,
										subParagraph: item.price,
									}}
									className={styles['item']}
								/>
							))}
				</div>
				{lowStock && <p className={styles['low-stock']}>{t('common:lowStock', { count: itemSelected?.stock })}</p>}
			</div>
		)
	);
};

const items = {
	_id: PropTypes.string,
	attributes: PropTypes.shape({
		format: PropTypes.shape({ shortValue: PropTypes.string }),
		nbunit: PropTypes.shape({ value: PropTypes.string }),
		conditionnement: PropTypes.shape({ name: PropTypes.string }),
	}),
	listPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	offerPrice: PropTypes.number,
	partnumber: PropTypes.string,
};

BlocSelector.propTypes = {
	t: PropTypes.func,
	items: PropTypes.arrayOf(PropTypes.shape(items)),
	itemSelected: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string,
	}),
	onSelect: PropTypes.func,
	isMobileOrTablet: PropTypes.bool,
};

export default BlocSelector;
